import React from 'react';
import { AdvancedMode } from '../../../shared/components/AdvancedMode';
import { WorkforceInput } from '../part/calculator-inputs/WorkforceInput';
import { useCalculatorNavigate } from '../../../shared/utils/calculatorNavigate';

export function Workforce(): JSX.Element {
    const navigate = useCalculatorNavigate();

    return (
        <article className='calculatorInput'>

            <AdvancedMode/>

            <div className='card'>

                <WorkforceInput/>

            </div>

            <div className='-o-back-next'>

                <div>
                    <button className='acc-o-button'
                            onClick={() => navigate('operations')}>
                        <span>Back</span>
                    </button>
                </div>

                <div>
                    <button className='acc-o-button' onClick={() => navigate('economical')}>
                        <span>OK / Next</span>
                    </button>
                </div>

            </div>

        </article>
    );
}
